<!--常见的tab
-->
<template>
	<div class="tabBody" v-if='show'>
		<!-- <div class="mask" @click="cancel"></div> -->
		<div class="tabBody-box">
			<p class="titles">
				<span class="t_title">{{title}}</span>
				<img @click.stop='show = false' :src="closeImg" class="closeImage"/>
			</p>
			<!-- <p class="normal-info" v-if="showInput && slotType =='dataList'"> ref="box" v-if='show'
				<span class="t_title">{{label}}</span>
				<input class="input-class" v-model="nowTab.templateName" />
			</p> -->
			<div ref="top" class="tab" v-if="slotType =='dataList'">
				<div :key="i" class="tabitem" :style='tabStyle(item)' v-for="(item,i) in tabDatas" @click="chooseTab(item)">
					{{getTabLabel(item)}}
					<span style="position: relative;width: 0;height: 0;margin-top:-0.4rem;margin-left:calc(100% - 0.13rem);display: block;z-index:100">
						<img :src="closeImg" class="closeImage" style="z-index:100" @click.stop='deleteTab(item)' />
					</span>
				</div>
				<!-- <div style='min-width: 1rem;height: .3rem;display: flex;justify-content: center;align-items: center;'>
				<img style="width: .3rem;height: .3rem;background-color: #008ADB;border-radius: 0.15rem;" :src="addImg" @click='newTab' />
				</div> -->
			</div>
			
			<div :style='dataBody'>
				<flexSelectDatas class='hideBar' v-if='slotType == "dataList"' @checkItem='nowSelect' :dataList='getDatasWithTab'
				 :defaultList='getDefaultList'></flexSelectDatas>
				<twiceGroupMove @add='add' @update='update' :isSame='isSameItem' v-else ref='twiceGroupMove' :rightDefaultValue='defaultValue'
				 :buttonList='buttonList'></twiceGroupMove>
			</div>
			<div class='button-line'>
				<div class='button-class' @click='saveTemplate' v-if='slotType == "dataList"'>保存模板</div>
				<div class='button-class' @click='confirm'>确定</div>
				<div class='button-class' @click='cancel'>取消</div>
			</div>
		</div>
	</div>
</template>

<script>
	import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	import unitStore from '@/cache/unitStore.js'
	import flexSelectDatas from './flexSelectDatas.vue'
	import teamAssessmentStore from '@/cache/teamAssessmentStore.js'
	import twiceGroupMove from './twiceGroupMove.vue'
	export default {
		components: {
			flexSelectDatas,
			twiceGroupMove,
		},
		props: {
			confirmCallBack: {
				type: Function,
				default: (a, b) => {
					return true
				}
			},
			cancelCallBack: {
				type: Function,
				default: (a, b) => {
					return true
				}
			},
			label: {
				type: String,
				default: ''
			},
			title: {
				type: String,
				default: ''
			},
			tabList: {
				type: Array,
				default: () => {
					return []
				}
			},
			slotType: {
				type: String,
				default: 'dataList'
			},
			dataList: {
				type: [Array, Object],
				default: () => {
					return []
				}
			},
			defaultValue: {
				type: Object,
				default: () => {
					return {}
				}
			},
			defaultList: { //仅仅给flexList 默认选中
				type: Object,
				default: () => {
					return {}
				}
			},
			isSame: {
				type: Function,
				default: (a, b) => {
					return a == b
				}
			},
			getTabLabel: {
				type: Function,
				default: (a) => {
					return a ? a.templateName : ''
				}
			},
			// 			buttonList: {
			// 
			// 			}
		},
		data() {
			return {
				nowTab: undefined,
				tabDatas: [],
				selectList: [],
				show: false,
				showInput: false,
				buttonList: [{
						name: '新建组',
						buttonFunction: (left, leftKey, right, rightKey) => {
							var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
							dialog.open('新建设备组', [{
								name: '组名',
								pkid: 'name'
							}], result => {
								if (isempty(result.name) ) {
									this.$dialogMethod.showMessage("组名称不能为空!")
									return false
								}
								var parentId = right ? right.id : unitStore.state.nowUnit.id
								var deviceList = left.map(i => {
									return {
										"deviceNo": i.no,
										"deviceName": i.name
									}
								})
								if(isempty(deviceList)){
									this.$dialogMethod.showMessage("请至少选择一个虚拟设备!")
									return false
								}
								this.$api.teamAssessmentApi.addVirtualDeviceGroup(result.name, parentId, deviceList,
									res => {
										this.$dialogMethod.showMessage("新增设备组成功!")
										teamAssessmentStore.commit('getDeviceGroupTree')
									}, res => {
										this.$dialogMethod.showMessage(res)
									}
								)

							})
						}
					},
					{
						name: '删除组',
						buttonFunction: (left, leftKey, right, rightKey) => {
							if (isempty(right) || right.type == "UsePowerUnit") {
								this.$dialogMethod.showMessage("请选择一个组")
								return
							}
							this.$api.teamAssessmentApi.deleteVirtualDeviceGroup(right.groupId,
								res => {
									this.$dialogMethod.showMessage("删除设备组成功!")
									teamAssessmentStore.commit('getDeviceGroupTree')
								}, res => {
									this.$dialogMethod.showMessage(res)
								}
							)
							//删除右边显示的项
							this.$refs.twiceGroupMove.$refs.virtualRightDeviceTree.$refs.treeBean.nowCheckItem = undefined
							this.$emit('add', this.rightData)
						}
					},
					{
						name: '添加设备',
						buttonFunction: (left, leftKey, right, rightKey) => {
							if (isempty(right) || right.type == "UsePowerUnit") {
								this.$dialogMethod.showMessage("请选择一个组,没有请先创建!")
								return
							}
							// this.$refs.twiceGroupMove.$refs.virtualRightDeviceTree.$refs.treeBean.nowCheckItem = undefined
							this.rightSelect = undefined
							var deviceList = left.map(i => {
								return {
									"deviceNo": i.no,
									"deviceName": i.name
								}
							})
							this.$api.teamAssessmentApi.updateVirtualDeviceGroup(right.groupId, right.groupName, deviceList,
								res => {
									this.$dialogMethod.showMessage("添加设备成功!")
									teamAssessmentStore.commit('getDeviceGroupTree')
								}, res => {
									this.$dialogMethod.showMessage(res)
								}
							)
						}
					}

				],
			}
		},
		created() {

		},
		mounted() {
			this.initData()
		},
		destroyed() {},
		computed: {
			// 			showInput() {
			// 				return this.tabList.length == 0 || this.isNew
			// 			},
			// 			isNew() {
			// 				return ( this.nowTab.tabType =='edit' || this.nowTab.tabType == 'new')
			// 			},
			dataBody() {
				var i = 1.3;
				if (this.slotType == 'dataList') {
					i += 0.5
				}
				if(this.slotType == 'twice'){
					i = 1.0
				}
				return {
					'height': 'calc(100% - ' + i + 'rem)',
					'width': '100%'
				}
			},
			tabStyle() {
				return item => {
					if (!isempty(this.nowTab) && item.pkid == this.nowTab.pkid) {
						return {
							// 'color': '#2D9FFF',
							'border': '1px solid #5599FF',
							'background-color': '#5599FF'
						}
					} else {
						return {
							// 							'color': '#7f8c96',
							// 							'border': '1px solid #7f8c96',
							// 							'background-color': '#bfd5e8'
						}
					}
				}
			},
			addImg() {
				return resourcesStore.getters.getResourcesByName('wedoButton/add.png')
			},
			closeImg() {
				return resourcesStore.getters.getResourcesByName('wedoButton/close.png')
			},
			getDatasWithTab() {
				if (this.dataList instanceof Array) {
					return this.dataList
				}
				if (this.nowTab) {
					return this.dataList[this.nowTab.pkid]
				}
				return []
			},
			getDefaultList() {
				if (!isempty(this.nowTab) && !isempty(this.defaultList) && this.nowTab.pkid) {
					return this.defaultList[this.nowTab.pkid]
				}
				if (!isempty(this.defaultValue) && !isempty(this.defaultValue.selectList)) {
					return this.defaultValue.selectList
				}

				return []
			}
		},
		watch: {
			show(nv, ov) {
				this.initData()
			}
		},
		methods: {
			deleteTab(tab) {
				this.$emit('deleteTab', tab)
			},
			update() {
				var temp = {
					tab: this.nowTab,
					selectList: this.$refs.twiceGroupMove.rightData
				}
				this.$emit('update', temp)
			},
			add() {
				var temp = {
					tab: this.nowTab,
					selectList: this.$refs.twiceGroupMove.rightData
				}
				this.$emit('add', temp)
			},
			isSameItem(a, b) {
				if (a == undefined || b == undefined) {
					return false
				}
				if (a.groupId == undefined || b.groupId == undefined) {
					return false
				}
				return a.groupId == b.groupId
			},
			saveTemplate() {
				// 				if (this.slotType == 'dataList') {
				// 					var temp = {
				// 						tab: this.nowTab,
				// 						selectList: this.selectList,
				// 					}
				// 					log(this.nowTab,'this.nowTab')
				// 				} else {
				// 					var temp = {
				// 						tab: this.nowTab,
				// 						selectList: this.$refs.twiceGroupMove.rightData
				// 					}
				// 				}
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('保存模板', [{
					name: '模板名称',
					pkid: 'name'
				}], result => {
					if (isempty(result.name)) {
						this.$dialogMethod.showMessage("模板名称不能为空!")
						return false
					}
					var tab = {
						'tabType': 'new',
						'templateName': result.name
					}
					var temp = {
						tab,
						selectList: this.selectList,
					}
					this.$emit('saveTemplate', temp)
				})


			},
			initData() {
				this.tabDatas = []
				this.nowTab = undefined
				if (!isempty(this.tabList)) {
					this.tabList.forEach(i => {
						if (i.default) { //默认勾选
							this.nowTab = i
						}
					})
					this.tabDatas = copy(this.tabList)
					// 					this.tabDatas.push({
					// 						templateName: '自定义模板',
					// 						tabType: 'new'
					// 					})
					// this.nowTab = this.tabDatas[this.tabDatas.length - 1]
				} else {
					// 					if (this.slotType == 'dataList') {
					// 						this.tabDatas.push({
					// 							templateName: '自定义模板',
					// 							tabType: 'new'
					// 						})
					// 						this.nowTab = this.tabDatas[0]
					// 					}
					// 					else {
					// 						this.tabDatas.push({
					// 							templateName: '新建设备组',
					// 							tabType: 'new'
					// 						})
					// 						this.nowTab = this.tabDatas[0]
					// 					}
				}


			},
			newTab() {
				var lastTab = this.tabDatas[this.tabDatas.length - 1]
				if (lastTab.tabType == 'new') {
					this.$dialogMethod.showMessage("有未保存的模板")
					return
				}
				var newtab = {
					templateName: '新建模板',
					tabType: 'new'
				}
				this.tabDatas.push(newtab)
				lastTab = this.tabDatas[this.tabDatas.length - 1]
				this.nowTab = lastTab

			},
			nowSelect(list) {
				var temp = list.sort((a, b) => {
					return a > b ? 1 : -1
				})
				this.selectList = temp
			},
			chooseTab(item) {
				this.showInput = true
				this.nowTab = item;
				this.selectList = [];
				// this.titleName = item.titleName;
				this.$emit("chooseTab", item)
			},
			cancel() {

				if (this.cancelCallBack() == false) {

				} else {
					this.show = false
					this.showInput = false
				}
			},
			confirm() {

				if (this.confirmCallBack() == false) {

				} else {
					var temp
					if (this.slotType == 'dataList') {
						temp = {
							tab: this.nowTab,
							selectList: this.selectList
						}
					} else {
						temp = this.$refs.twiceGroupMove.rightSelect
						if (isempty(temp) || temp.type != "VirtualDeviceGroup") {
							this.$dialogMethod.showMessage("请选择一个组,没有请先创建!")
							return
						}
					}
					this.$emit("confirm", temp)
					this.showInput = false
					this.show = false
				}

			}
		}
	}
</script>

<style scoped>
	.input-class {
		border-radius: 0.05rem;
		margin: 0 0.1rem;
		border: 1px solid #0092DC;
		padding: 0 0.1rem;
		height: 0.2rem;
		width: calc(100% - 1rem);
		font-size: 0.15rem;
	}

	.tabBody {
		/* border-radius: 0.1rem; */
		width: 101%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
	}

	.t_title {
		min-width: 1rem;
		font-size: .18rem;
		color: #0092DC;
	}
	
	.mask{
		z-index: 102;
	}
	.tabBody-box{
		/* overflow: hidden; */
		
		/* z-index: 103; */
		border-radius: 0.1rem;
		width: 100%;
		height: 77%;
		background: white;
		margin: 0.5rem auto;
	}

	.normal-info {
		width: calc(100% - 0.4rem);
		height: .25rem;
		padding: 0 0.2rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.closeImage {
		width: 0.25rem;
		height: 0.25rem;
	}

	.titles {
		width: calc(100% - 0.4rem);
		height: .5rem;
		padding: 0 0.2rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.select {
		background-color: #10A4E2;
	}

	.button-line {
		height: .5rem;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.table-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #515A6E;
		height: 38px;
		width: 100%;
		/* width: calc(100% - 1rem - 1px); */
	}

	.tree-column {
		/* padding-right: 10px;
		padding-left: 5px; */
		height: 38px;
		line-height: 38px;
		width: 2rem;
		border-left: 1px solid #000000;
	}

	.item-other {
		line-height: 38px;
		flex-grow: 1;
		border-left: 1px solid #000000;
	}

	.tab {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		/* color: #515A6E; */
		height: .8rem;
		background: white;
		/* overflow: hidden; */
		overflow-x: scroll;
	}

	.tabitem {
		/* overflow: hidden; */
		text-overflow: ellipsis;
		white-space: nowrap;
		margin: 0 0 0 0.2rem;
		line-height: 0.3rem;
		height: 0.3rem;
		text-align: center;
		min-width: 1rem;
		font-size: 0.15rem;
		border-radius: 0.05rem;
		color: white;
		background-color: #939da7;
		font-family: Microsoft YaHei;
		cursor: pointer;
	}

	.tabitem:hover {
		/* 鼠标移入按钮范围时改变颜色 */
		background: #5599FF;
	}

	#resize {
		line-height: 100%;
		width: 10px;
		height: 100%;
		cursor: w-resize;
		float: left;
		background-color: #cacaca;
	}

	#resize img {
		height: 100%;
		width: 10px;
	}

	.item-other-group {
		margin-right: 30px;
		display: flex;
		align-content: center;
		width: 10rem;
	}

	.body {
		height: calc(100% - 1.85rem);
		width: 100%;
	}

	.button-class {
		font-size: 0.12rem;
		text-align: center;
		line-height: 0.25rem;
		border-radius: 0.05rem;
		color: white;
		background-color: #939da7;
		margin: 0 0.2rem;
		width: .8rem;
		height: 0.25rem;
		font-family: Microsoft YaHei;
		cursor: pointer;
	}

	.button-class:hover {
		/* 鼠标移入按钮范围时改变颜色 */
		background: #5599FF;
	}
</style>
